import { FC, ReactElement } from 'react';
import cn from 'classnames';

import { TooltipWrap } from 'components/ui/TooltipWrap';

interface SidebarButtonProps {
  isActive: boolean;
  onClick: () => void;
  activeIcon: ReactElement;
  passiveIcon: ReactElement;
  title: string;
}

export const SidebarButton: FC<SidebarButtonProps> = ({
  isActive,
  onClick,
  activeIcon,
  passiveIcon,
  title,
}) => (
  <TooltipWrap title={title} placement="bottom-start">
    <div
      className={cn(
        'w-8 h-8 [&>*]:w-full [&>*]:h-full',
        isActive ? '!text-bright_product' : '!text-tpg_base',
        'hover:!text-dark_product'
      )}
      onClick={onClick}
    >
      {isActive ? activeIcon : passiveIcon}
    </div>
  </TooltipWrap>
);
